import type { SVGProps } from "react";

export function IconBlackCart(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        d="M58 51.5C58 54.5376 55.5376 57 52.5 57C49.4624 57 47 54.5376 47 51.5C47 48.4624 49.4624 46 52.5 46C55.5376 46 58 48.4624 58 51.5Z"
        fill="#23232C"
      />
      <path
        d="M26 51.5C26 54.5376 23.5376 57 20.5 57C17.4624 57 15 54.5376 15 51.5C15 48.4624 17.4624 46 20.5 46C23.5376 46 26 48.4624 26 51.5Z"
        fill="#23232C"
      />
      <path
        d="M57 42H16V7H7M58 51.5C58 54.5376 55.5376 57 52.5 57C49.4624 57 47 54.5376 47 51.5C47 48.4624 49.4624 46 52.5 46C55.5376 46 58 48.4624 58 51.5ZM26 51.5C26 54.5376 23.5376 57 20.5 57C17.4624 57 15 54.5376 15 51.5C15 48.4624 17.4624 46 20.5 46C23.5376 46 26 48.4624 26 51.5Z"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.75 6.25H53.25V37.75H21.75V6.25H33.25V14.75H41.75V6.25ZM40.25 6.25H34.75V13.25H40.25V6.25Z"
        fill="#23232C"
      />
    </svg>
  );
}
